import BaseWindow from "../core/views/BaseWindow";
import C_PointerEvt from "../core/const/C_PointerEvt";
import Button from "../core/ui/Button";
import C_GameEvent from "../core/const/C_GameEvent";

class BaseChoosePopup extends BaseWindow
{
    constructor(leftCallback, rightCallback)
    {
        super();
        document.body.style.cursor = "url('styles/custom_cursor1.png') 5 5, auto";
        this.descriptionText = "";
        this.butSize = 6.5;
        this.textSize = this.layout.relHeight(3);
        this.butTxtColor = "#00485d";
        this.gap = this.layout.relWidth(1);

        this._leftCallback = leftCallback;
        this._rightCallback = rightCallback;

        this.on(C_PointerEvt.MOVE, this.onMove, this);
    }


    onMove(e)
    {
        e.stopPropagation();
    }


    setText(text)
    {
        this.descriptionText = text;
    }


    drawContent()
    {
        this.createRow();

        this.description = this.assets.getTF(this.descriptionText, this.textSize, null, '#ffffff', 1.3);
        this.currentRow.addChild(this.description);
    }


    calculateBgSize()
    {
        super.calculateBgSize();
        this.winBg = this.assets.getSprite("base_popup_bg");
        let bgAspectRatio = this.winBg.width/this.winBg.height;

        let minWidth = this.layout.relHeight(this.butSize*6) + this.gap*4;
        this.winBgWidth = (minWidth > this.winBgWidth) ? minWidth : this.winBgWidth;

        if (this.winBgWidth/this.winBgHeight > bgAspectRatio)
        {
            this.winBg.width = this.winBgWidth;
            this.winBg.height = this.winBgWidth/bgAspectRatio;
        }
        else
        {
            this.winBg.height = this.winBgHeight;
            this.winBg.width = this.winBgHeight*bgAspectRatio;
        }
    }


    drawBackground()
    {
        this.addChildAt(this.winBg, this.getChildIndex(this.container));
        this.layout.horizontalAlignCenter(this.winBg, -50);
        this.layout.verticalAlignMiddle(this.winBg, -50);
    }


    drawAfterSizing(){ }


    drawCloseBut(){ }


    drawButtons(leftText, rightText)
    {
        leftText = leftText == undefined ? "Yes" : leftText;
        rightText = rightText == undefined ? "No" : rightText;

        this.leftButton = new Button("base_button", "base_button_hover", "base_button_hover");
        this.layout.propHeightScale(this.leftButton, this.butSize);
        this.addChild(this.leftButton);
        this.layout.horizontalAlignCenter(this.leftButton, 0, this.winBg);
        this.leftButton.x -= this.leftButton.width*.5 + this.gap;
        this.layout.verticalAlignBottom(this.leftButton, 13, this.winBg);

        let leftTF = this.assets.getTF(leftText, this.leftButton.height*.5, null, this.butTxtColor);
        this.addChild(leftTF);
        this.layout.horizontalAlignCenter(leftTF, 0, this.leftButton);
        this.layout.verticalAlignMiddle(leftTF, 0, this.leftButton);

        this.rightButton = new Button("base_button", "base_button_hover", "base_button_hover");
        this.layout.propHeightScale(this.rightButton, this.butSize);
        this.addChild(this.rightButton);
        this.layout.horizontalAlignCenter(this.rightButton, 0, this.winBg);
        this.rightButton.x += this.rightButton.width*.5 + this.gap;
        this.layout.verticalAlignBottom(this.rightButton, 13, this.winBg);

        let rightTF = this.assets.getTF(rightText, this.leftButton.height*.5, null, this.butTxtColor);
        this.addChild(rightTF);
        this.layout.horizontalAlignCenter(rightTF, 0, this.rightButton);
        this.layout.verticalAlignMiddle(rightTF, 0, this.rightButton);


        this.leftButton.on(C_PointerEvt.DOWN, this.onLeftButClick, this);
        this.rightButton.on(C_PointerEvt.DOWN, this.onRightButClick, this);
    }


    onLeftButClick(e)
    {
        if (this._leftCallback)
        {
            TweenMax.delayedCall(.05, this._leftCallback);
        }

        this.close();
    }


    onRightButClick(e)
    {
        if (this._rightCallback)
        {
            TweenMax.delayedCall(.05, this._rightCallback);
        }

        this.close();
    }


    close()
    {
        super.close();
        TweenMax.delayedCall(0.3, this.postRemove, null, this);
    }


    postRemove()
    {
        this.dispatcher.emit(C_GameEvent.POPUP_CLOSED);
    }

}

export default BaseChoosePopup;